<div class="color-bar"></div>

<div>    
    <app-bi-pcauio-lista
        [filtros]="filtros"
        (exibir)="selecionar($event)">    
    </app-bi-pcauio-lista>
</div>
